import downloadReducer from './reducers'

export { default as downloadSelectors } from './selectors'
export { default as downloadOperations } from './operations'
export { default as downloadTypes } from './types'

export default downloadReducer
